import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const NotFound404 = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, p: 4 }}>
    <ErrorOutline sx={{ fontSize: 64, color: '#DC143C', mb: 2 }} />
    <Typography variant="h4" sx={{ color: '#DC143C', fontWeight: 'bold', mb: 1 }}>404 - Page Not Found</Typography>
    <Typography variant="body1" color="textSecondary" align="center" sx={{ mb: 2 }}>
      The page you are looking for does not exist.<br />
      Please check the URL or return to the dashboard.
    </Typography>
    <Button component={RouterLink} to="/admin/dashboard" variant="contained" sx={{ backgroundColor: '#DC143C', '&:hover': { backgroundColor: '#B91C3C' } }}>
      Go to Dashboard
    </Button>
  </Box>
);

export default NotFound404; 